<script>
import { Container, Draggable } from 'vue-smooth-dnd'
import CKEditor from "@ckeditor/ckeditor5-vue";
import ClassicEditor from "ckeditor5-build-classic-with-font";
import Switches from "vue-switches";
import Multiselect from "vue-multiselect";
import moment from "moment";
import api from "../../api";

Array.prototype.move = function(from, to) {
  this.splice(to, 0, this.splice(from, 1)[0]);
};

export default {
  props: ['schema', 'formData', 'selectedItem',
  'form_formData_locations', 'form_formData_member_group', 'form_formData_member_subgroup', 'category'],
  components: { 
    ckeditor: CKEditor.component,
    Multiselect,
    Switches,
    Container,
    Draggable
  },
  data() {
    return {
      formData_locations: this.form_formData_locations,
      formData_member_group: this.form_formData_member_group,
      formData_member_subgroup: this.form_formData_member_subgroup,
      selectedRadio: this.formData.further_details,
      selectedRadioGender: this.formData.gender,
      moment: moment,
      enabled: false,
      editorData: "",
      group: '',
      subgroup: '',
      editor: ClassicEditor,
      editorConfig: {
        toolbar: ['heading', '|', 'fontColor', '|', 'bold', 'italic', 'link', 'bulletedList', 'numberedList', 'blockQuote', 'insertTable', 'undo', 'redo'],
        heading: {
          options: [
            { model: 'paragraph', title: 'Paragraph', class: 'ck-heading_paragraph' },
            { model: 'heading1', view: 'h1', title: 'Heading 1', class: 'ck-heading_heading1' },
            { model: 'heading2', view: 'h2', title: 'Heading 2', class: 'ck-heading_heading2' },
            { model: 'heading3', view: 'h3', title: 'Heading 3', class: 'ck-heading_heading3' },
            { model: 'heading4', view: 'h4', title: 'Heading 4', class: 'ck-heading_heading4' }
          ]
        },
        table: {
          contentToolbar: ['tableColumn', 'tableRow', 'mergeTableCells']
        },
        fontColor: {
          colors: [
            {
              color: '#005EB8',
              label: 'Blue'
            },
            {
              color: '#FF2E2E',
              label: 'Red'
            },
            {
              color: '#4F535B',
              label: 'Main Grey'
            }
          ]
        },
        link: {
          decorators: {
            toggleDownloadable: {
              mode: 'manual',
              label: 'Downloadable',
              attributes: {
                download: 'file'
              }
            },
            openInNewTab: {
              mode: 'manual',
              label: 'Open in a new tab',
              attributes: {
                target: '_blank',
                rel: 'noopener noreferrer'
              }
            }
          }
        }
      },
    };
  },
  watch: {
        form_formData_locations: {
            handler: function(newValue) {
              this.formData_locations = newValue;
            }
        },
        form_formData_member_group: {
            handler: function(newValue) {
              this.formData_member_group = newValue;
            }
        },
        form_formData_member_subgroup: {
            handler: function(newValue) {
              this.formData_member_subgroup = newValue;
            }
        },
        formData_locations: {
            handler: function(newValue) {
              if(this.form_formData_locations != newValue) {
                this.$emit('selected-member-location', newValue);
              }
            }
        },
        formData_member_group: {
            handler: function(newValue) {
              if(this.form_formData_member_group != newValue) {
                this.$emit('selected-member-group', newValue);
              }
            }
        },
        formData_member_subgroup: {
            handler: function(newValue) {
              if(this.form_formData_member_subgroup != newValue) {
                this.$emit('selected-member-subgroup', newValue);
              }
            }
        },
        enabled(val) {
          if ('featured' in this.formData) {
            this.formData['featured'] = val;
          }
          else if ('reduced_hours' in this.formData) {
            this.formData['reduced_hours'] = val;
          }
        },
        formData: {
            handler: function(newValue) {
                if('further_details' in newValue) {
                  this.selectedRadio = newValue.further_details;
                }
                if('gender' in newValue) {
                  this.selectedRadioGender = newValue.gender;
                }
                if('featured' in newValue) {
                  this.enabled = newValue.featured;
                }
                else if ('reduced_hours' in newValue) {
                this.enabled = newValue.reduced_hours;
                }
                if(newValue.location) this.$emit('selected-location', newValue.location);
                if(newValue.groups) this.$emit('selected-group', newValue.groups);
                if(newValue.subgroups) this.$emit('selected-subgroup', newValue.subgroups);
            },
            deep: true
        }
    },
  methods: {
    toggleChanged(key, e) {
      if(this.formData[key] != e) {
        this.$emit('toggle-change', key, e);
      }
    },
    changeValueRadio(key, val) {  
      this.$emit('radio-change', key, val);
      this.selectedRadio = val;
      console.log(this.selectedRadio);
    },
    changeGenderValueRadio(key, val) {  
      this.$emit('radio-change-gender', key, val);
      this.selectedRadioGender = val;
      console.log(this.selectedRadioGender);
    },
    selectedItemFn(val) {
      this.$emit('selected-item', val);
    },
    addGroup(val) {
      this.$emit('add-group', val);
      this.group = '';
    },
    addSubGroup(val) {
      this.$emit('add-subgroup', val);
      this.subgroup = '';
    },
    removeGroup(val) {
      this.$emit('remove-group', val);
    },
    removeSubGroup(val) {
      this.$parent.$emit('remove-subgroup', val);
    },
    positionDown(item, list) {
      const matchId = (el) => el.id == item.id;
      var fromIndex = list.findIndex(matchId)
      if(fromIndex != list.length) {
        var toIndex = fromIndex + 1;
        list.move(fromIndex, toIndex);

        item.additionalProp1.position = toIndex;
        this.updatePage(item);
        
        var secondItem = list[fromIndex];
        secondItem.additionalProp1.position = fromIndex;
        this.updatePage(secondItem);
      }    
    },
    positionUp(item, list) {
      const matchId = (el) => el.id == item.id;
      var fromIndex = list.findIndex(matchId)
      if(fromIndex) {
        var toIndex = fromIndex - 1;
        list.move(fromIndex, toIndex)  
        
        item.additionalProp1.position = toIndex;
        this.updatePage(item);
        
        var secondItem = list[fromIndex];
        secondItem.additionalProp1.position = fromIndex;
        this.updatePage(secondItem);
      }
    },
    updatePage(item) {
      var data = {
        additionalProp1: item.additionalProp1
      };
      api.patch('/api/pages/'+item.id, data)
      .then(() => {
      }, (error) => {
        console.log(error);
      });  
    },
    getChildPayload(itemIndex, list) {
      return list[itemIndex]
    },
    async onDrop(event, list) {
      await this.applyDrag(list, event)
    },
    async applyDrag(arr, dragResult) {
      const { removedIndex, addedIndex, payload } = dragResult
      if (removedIndex === null && addedIndex === null) return arr

      const result = [...arr]
      let itemToAdd = payload

      if (removedIndex !== null) {
        itemToAdd = result.splice(removedIndex, 1)[0]
      }

      if (addedIndex !== null) {
        result.splice(addedIndex, 0, itemToAdd)
      }

      result.forEach((item, index) => {
        const fromIndex = arr.findIndex(arrItem => arrItem.id === item.id)
        arr.move(fromIndex, index)
        item.additionalProp1.position = index
        this.updatePage(item)
      })

      return result
    },
    getChildPayloadGroups(itemIndex, list) {
      return list[itemIndex]
    },
    async onDropGroups(event, list) {
      await this.applyDragGroups(list, event)
      await this.updateGroups(list)
    },
    applyDragGroups(arr, dragResult) {
      const { removedIndex, addedIndex, payload } = dragResult
      if (removedIndex === null && addedIndex === null) return arr

      const result = [...arr]
      let itemToAdd = payload

      if (removedIndex !== null) {
        itemToAdd = result.splice(removedIndex, 1)[0]
      }

      if (addedIndex !== null) {
        result.splice(addedIndex, 0, itemToAdd)
      }

      result.forEach((item, index) => {
        const fromIndex = arr.findIndex(arrItem => arrItem.id === item.id)
        arr.move(fromIndex, index)
      })

      return result
    },
    async updateGroups(list) {
      let where = {
        name: {
          like: 'Practice Team',
          options: "i"
        }
      };
      where = encodeURIComponent(JSON.stringify(where));
      
      var data = this.category;
      data.additionalProp1.groups = list;

      try {
        await api.patch(`/api/cms/${this.currentCms.id}/categories?where=${where}`, data);
      } catch (err) {
        console.error(err);
      }
    }
  },
  mounted() {
    this.enabled = this.formData.additionalProp1.featured;
  }
};
</script>

<template>
  <form class="needs-validation w-100">
    <div class="row">
      <div v-for="item, key in schema" :key="key" :class="item.wrapper_class ? item.wrapper_class : 'col-md-12'"
      >
        <div class="form-group"
            :class="{ 'd-none': (formData.status && !formData.status.filter(y => y.name == 'Interim Closure')[0].value && item.label == 'Second Opening Time') || 
            (formData.status && !formData.status.filter(y => y.name == 'Interim Closure')[0].value && item.label == 'Second Closing Time') ||
            (formData.upload_options && formData.upload_options == 'Video' && item.label == 'Image') || 
            (formData.upload_options && formData.upload_options == 'Image' && item.label == 'Video URL') ||
            (selectedRadio && selectedRadio.name == 'External Link' && item.label == 'Select News Item') ||
            (selectedRadio && selectedRadio.name == 'News Item' && item.label == 'Enter Link Here') ||
            (item.label == 'Info Title' && !schema.info_box.options[0].value) ||
            (item.label == 'Info Description' && !schema.info_box.options[0].value)
            }">
          <div v-if="item.type == 'seperator'" class="w-100 my-4" style="border-bottom: 1px solid #DADCE3;"></div>
          <div v-if="item.label" class="d-flex">
            <label
            class="pr-2 my-2 align-self-sm-center font-theme-black-color font-weight-medium"
            :class="item.type == 'heading' ? 'font-size-30' : '' ||
            item.type == 'paragraph' ? 'font-weight-normal' : ''"
            :for="key + _uid">{{item.label}}<span v-if="item.required"
            > *</span></label>
            <img v-if="item.info" :id="key + _uid" variant="primary" class="align-self-center" src="@/assets/images/info.svg" alt="">
            <!-- <i :id="key + _uid" variant="primary" class="ri-information-fill my-auto font-size-18 font-gray-color"></i> -->
            <b-tooltip :target="key + _uid">{{item.tooltip ? item.tooltip : 'Enter '+item.label}}</b-tooltip>
            <p v-if="item.character_count > 0" class="font-size-14 mb-2 font-weight-medium text-muted ml-auto align-self-sm-center">Character Count: {{formData[key] ? formData[key].length : 0}} / {{item.character_count}}</p>          
            <a v-if="item.label == 'Sub-groups'" v-b-modal.modal-center-subgroup class="font-size-14 mb-2 ml-auto align-self-sm-center">+ Add Item</a>     
            <p v-if="item.type == 'list'" class="font-size-14 mb-2 text-muted ml-auto align-self-sm-center">
              <span>Total: {{item.options.length}} </span>|<span> Active: {{item.options.filter((x => x.active == true)).length}}</span>
            </p>
            <!-- <img v-b-modal.modal-center class="align-self-center ml-2"
            src="@/assets/images/addbtngreen.svg" alt=""> -->
            <b-modal
              v-if="item.extra_label == 'Manage Groups'"
              style="letter-spacing: 2em;"
              id="modal-center-group"
              centered
              :title="item.extra_label"
              title-class="font-18"
              hide-footer
            >
              <div class="d-flex mb-3">
                <input v-model="group" type="text" class="form-control mr-2" />  
                <button class="btn btn-primary" @click="addGroup(group)">Add</button>
              </div>
              <div>
                <ul class="list-unstyled chat-list">
                  <li
                    v-for="data of item.options"
                    :key="data.id"
                  >
                    <a href="javascript: void(0);"
                    class="group-modal"
                    style="background: #eff7fb; border-top: none;"
                    >
                      <div class="media">
                        <div class="media-body overflow-hidden p-2 d-flex justify-content-between">
                          <span class="text-truncate font-size-16 mb-0 px-2">
                            {{data.title}}
                          </span>
                          <i class="ri-close-circle-fill" style="font-size: medium;" @click="removeGroup(data.title)"></i>
                        </div>
                      </div>
                    </a>
                  </li>
                </ul>            
              </div>
            </b-modal>

            <b-modal
              v-if="item.extra_label == 'Manage Sub-Groups'"
              style="letter-spacing: 2em;"
              id="modal-center-subgroup"
              centered
              :title="item.extra_label"
              title-class="font-18"
              hide-footer
            >
              <div class="d-flex mb-3">
                <input v-model="subgroup" type="text" class="form-control mr-2" />  
                <button class="btn btn-primary" @click="addSubGroup(subgroup); $bvModal.hide('modal-center-subgroup')">Add</button>
              </div>
            </b-modal>
          </div>

          <div v-if="item.type == 'file'" class="custom-file col-6">
            <input :id="key + _uid" type="file" class="custom-file-input" />
            <label class="custom-file-label" :for="key + _uid">Choose file</label>
          </div>
          <ckeditor v-else-if="item.type == 'ckeditor'" v-model="formData[key]" :editor="editor" :config="editorConfig" :id="key + _uid"></ckeditor>
          
          <div v-else-if="item.type == 'checkbox'" class="row pl-3">
            <div v-for="option in item.options" v-bind:key="option.name" class="form-check col-12">
                <input class="form-check-input" type="checkbox" v-model="option.value" :id="option + _uid"/>
                <p class="form-check-label ml-1 mb-2" :for="option + _uid">{{option.name}}</p>
            </div>                      
          </div>
          <div v-else-if="item.type == 'radio' && item.label == 'Gender'" class="row container">
            <div v-for="option in item.options" v-bind:key="option.name" class="form-check mr-4">
              <input
                class="form-check-input"
                type="radio"
                name="exampleRadios"
                :id="option + _uid"
                :value="option" 
                :checked="selectedRadioGender && selectedRadioGender.name == option.name"
                @change="changeGenderValueRadio(key, option)"
              />
              <label class="form-check-label" :for="option + _uid">{{option.name}}</label>
            </div>            
          </div>
          <div v-else-if="item.type == 'radio'" class="row container">
            <div v-for="option in item.options" v-bind:key="option.name" class="form-check mr-4">
              <input
                class="form-check-input"
                type="radio"
                name="exampleRadios"
                :id="option + _uid"
                :value="option" 
                :checked="selectedRadio.name == option.name"
                @change="changeValueRadio(key, option)"
              />
              <label class="form-check-label" :for="option + _uid">{{option.name}}</label>
            </div>            
          </div>
          <div v-else-if="item.type == 'toggle-permissions'">
              <switches :value="formData[key]" @input="value => toggleChanged(key, value)" type-bold="false" color="info" class="mt-2"></switches>
          </div>
          <div v-else-if="item.type == 'toggle'">
              <switches v-model="enabled" @input="e => formData[key] = enabled" type-bold="false" color="info" class="mt-2"></switches>
          </div>
          <div v-else-if="item.type == 'subgroup'">
            <div v-for="(sg, i) of formData['subgroups']" :key="sg.id">
              <div class="d-flex">
              <label
                class="pr-2 my-2 align-self-sm-center font-theme-black-color font-weight-medium"
                :for="sg.id">Sub-group {{i + 1}}<span> *</span></label>
                <img v-if="item.info" :id="sg.id" variant="primary" class="align-self-center" src="@/assets/images/info.svg" alt="">
                <b-tooltip :target="sg.id">Enter Sub-group</b-tooltip>
                <a class="font-size-14 mb-2 font-weight-medium ml-auto align-self-sm-center" role="button" style="color: #da3f3f"
                v-on:click="removeSubGroup(sg)">Remove</a>      

              </div>
              <div>
                <input
                  v-model="sg.title"
                  type="text"
                  class="form-control mb-2"
                />
                <ckeditor v-model="sg.description" :editor="editor" :config="editorConfig" :id="sg.id"></ckeditor>
              </div>
            </div>

          </div>
          <div v-else-if="item.type == 'select'">
            <select 
             v-if="item.label == 'PCN'" class="form-control" v-model="formData[key]">
              <option v-for="option in item.options" v-bind:key="option.id"
              :selected="formData[key] == option.id" :value="option.id">{{option.name}}</option>
            </select>
            <select v-else-if="item.label == 'Select News Item'" class="form-control" v-model="formData[key]">
              <option v-for="option in item.options" v-bind:key="option.id" :value="option.id"
              :selected="formData[key] == option">{{option.title}}</option>
            </select>
            <select v-else class="form-control" v-model="formData[key]" :required="true">
              <option v-for="option in item.options" v-bind:key="option" :value="option"
              :selected="formData[key] == option || formData.media_type == option">{{option}}</option>
            </select>
          </div>

          <div v-else-if="item.type == 'color'">
            <div class="d-flex bg-white" style="border: 1px solid #ced4da; border-radius: 4px;">
              <div style="border-radius: 5px; overflow: hidden; width: 40px;">
                <input
                  :id="key + _uid"
                  v-model="formData[key]"
                  :max="item.character_count == 0 ? 10000 : item.character_count"
                  :maxlength="item.character_count == 0 ? 10000 : item.character_count"
                  :type="item.type"
                  class="form-control p-0 border-0"
                  style="width: 200%; height: 200%; transform: translate(-25%, -25%);"
                  :placeholder="item.placeholder"
                />                
              </div>
              <div class="pl-3 p-2" style="color: #949ca8;">
               {{formData[key] ? formData[key] : '#000000'}}
              </div>
            </div>
          </div>
          <div
          v-else-if="item.type == 'text' || 
            item.type == 'date' || item.type == 'number' || 
            item.type == 'email' || item.type == 'password'"
          >
          <div>
            <input
              :id="key + _uid"
              v-model="formData[key]"
              :max="item.character_count == 0 ? 10000 : item.character_count"
              :maxlength="item.character_count == 0 ? 10000 : item.character_count"
              :type="item.type"
              class="form-control"
              :placeholder="item.placeholder"
            />
          </div>
          </div>
          <div v-else-if="item.type == 'multiselect' && item.label == 'Groups'">
              <multiselect v-model="formData[key]" track-by="title" label="title" :allow-empty="false" :preselectFirst="true" :options="item.options">
                <template slot="singleLabel" slot-scope="{ option }"><strong>{{ option.title }}</strong></template>
              </multiselect>
          </div>
          <div v-else-if="item.type == 'multiselect' && item.label == 'Sub-group'">
              <multiselect v-model="formData[key]" track-by="title" label="title" :allow-empty="true" :preselectFirst="true" :options="item.options">
                <template slot="singleLabel" slot-scope="{ option }"><strong>{{ option.title }}</strong></template>
              </multiselect>
          </div>
          <div v-else-if="item.type == 'multiselect' && item.label == 'Location(s)'">
              <multiselect v-model="formData_locations" track-by="title" label="title" :multiple="true" :options="item.options">
                <template slot="singleLabel" slot-scope="{ option }"><strong>{{ option.title }}</strong></template>
              </multiselect>
          </div>
          <div v-else-if="item.type == 'multiselect' && item.label == 'Group'">
              <multiselect v-model="formData_member_group" track-by="title" label="title" :options="item.options">
                <template slot="singleLabel" slot-scope="{ option }"><strong>{{ option.title }}</strong></template>
              </multiselect>
          </div>
          <div v-else-if="item.type == 'multiselect' && item.label == 'Sub-Group'">
              <multiselect v-model="formData_member_subgroup" track-by="title" label="title" :options="item.options">
                <template slot="singleLabel" slot-scope="{ option }"><strong>{{ option.title }}</strong></template>
              </multiselect>
          </div>
          <div v-else-if="item.type == 'multiselect' && item.label == 'Location'">
              <multiselect v-model="formData[key]" track-by="title" label="title" :allow-empty="false" :preselectFirst="true" :options="item.options">
                <template slot="singleLabel" slot-scope="{ option }"><strong>{{ option.title }}</strong></template>
              </multiselect>
          </div>
          <div v-else-if="item.type == 'multiselect'">
              <multiselect v-model="formData[key]" track-by="title" label="title" :options="item.options">
                <template slot="singleLabel" slot-scope="{ option }"><strong>{{ option.title }}</strong></template>
              </multiselect>
          </div>
          <div v-else-if="item.type == 'list'">
              <p v-if="!item.options.length">No items found!</p>
              <ul class="list-unstyled chat-list" v-if="!item.draggable">
                <li
                  v-for="data of item.options"
                  :key="data.id"
                  :class="{ active: data.id == selectedItem.id }"
                  @click="selectedItemFn(data)"
                >
                  <a href="javascript: void(0);"
                  >
                    <div class="media">
                      <div class="media-body overflow-hidden p-2"
                        :style="data.additionalProp1 ? data.additionalProp1.color == 'Red' ? 'border-left: 5px solid red' : data.additionalProp1.color == 'Amber' ? 'border-left: 5px solid #FFB902' : data.additionalProp1.color == 'Green' ? 'border-left: 5px solid green' : '' : ''">
                        <p class="text-truncate font-size-16 mb-0 px-2">
                        <i v-if="data.additionalProp1 && 'featured' in data.additionalProp1 && data.additionalProp1.featured" class="ri-star-fill mr-2" style="color: gold;"></i>

                        <span :style="'active' in data && !data.active ? data.id !== selectedItem.id ? 'color: gray' : '' : ''">
                          {{ moment(data.title, "YYYY-MM-DD", true).isValid() ? moment(new Date(data.title)).format('DD MMMM, YYYY') : data.title}}
                        </span>
                        <!-- <i v-if="item.draggable" class="ri-arrow-down-line float-right ml-2" @click="positionDown(data, item.options)"></i>
                        <i v-if="item.draggable" class="ri-arrow-up-line float-right" @click="positionUp(data, item.options)"></i> -->
                        </p>
                      </div>
                    </div>
                  </a>
                </li>
              </ul>
              <template v-if="item.draggable && item.label == 'Groups'">
                <Container 
                  tag="ul"
                  class="list-unstyled chat-list"
                  drag-handle-selector=".draggable-item-trigger"
                  :get-child-payload="itemIndex => getChildPayloadGroups(itemIndex, item.options)"
                  @drop="onDropGroups($event, item.options)"
                >
                  <Draggable 
                    v-for="data of item.options" 
                    tag="li" 
                    :key="data.id" 
                    :class="{ active: data.id == selectedItem.id }"                    
                  >
                    <a href="javascript: void(0);" @click="selectedItemFn(data)">
                      <div class="media pl-3">
                        <div class="draggable-item-trigger handle"></div>
                        <div class="media-body overflow-hidden p-2"
                          :style="data.additionalProp1 ? data.additionalProp1.color == 'Red' ? 'border-left: 5px solid red' : data.additionalProp1.color == 'Amber' ? 'border-left: 5px solid #FFB902' : data.additionalProp1.color == 'Green' ? 'border-left: 5px solid green' : '' : ''">
                          <p class="text-truncate font-size-16 mb-0 px-2">
                          <i v-if="data.additionalProp1 && 'featured' in data.additionalProp1 && data.additionalProp1.featured" class="ri-star-fill mr-2" style="color: gold;"></i>
  
                          <span :style="'active' in data && !data.active ? data.id !== selectedItem.id ? 'color: gray' : '' : ''">
                            {{ moment(data.title, "YYYY-MM-DD", true).isValid() ? moment(new Date(data.title)).format('DD MMMM, YYYY') : data.title}}
                          </span>
                          </p>
                        </div>
                      </div>
                    </a>
                  </Draggable>
                </Container>
              </template>
              <template v-else-if="item.draggable">
                <Container 
                  tag="ul"
                  class="list-unstyled chat-list"
                  drag-handle-selector=".draggable-item-trigger"
                  lock-axis="y"
                  :drag-begin-delay="0"
                  :get-child-payload="itemIndex => getChildPayload(itemIndex, item.options)"
                  @drop="onDrop($event, item.options)"
                >
                  <Draggable 
                    v-for="data of item.options" 
                    tag="li" 
                    :key="data.id" 
                    :class="{ active: data.id == selectedItem.id }"                    
                  >
                    <a href="javascript: void(0);" @click="selectedItemFn(data)">
                      <div class="media">
                        <div class="draggable-item-trigger-container pl-3 handle">
                          <div class="draggable-item-trigger"></div>
                        </div>
                        <div class="media-body overflow-hidden p-2"
                          :style="data.additionalProp1 ? data.additionalProp1.color == 'Red' ? 'border-left: 5px solid red' : data.additionalProp1.color == 'Amber' ? 'border-left: 5px solid #FFB902' : data.additionalProp1.color == 'Green' ? 'border-left: 5px solid green' : '' : ''">
                          <p class="text-truncate font-size-16 mb-0 px-2">
                          <i v-if="data.additionalProp1 && 'featured' in data.additionalProp1 && data.additionalProp1.featured" class="ri-star-fill mr-2" style="color: gold;"></i>
  
                          <span :style="'active' in data && !data.active ? data.id !== selectedItem.id ? 'color: gray' : '' : ''">
                            {{ moment(data.title, "YYYY-MM-DD", true).isValid() ? moment(new Date(data.title)).format('DD MMMM, YYYY') : data.title}}
                          </span>
                          </p>
                        </div>
                      </div>
                    </a>
                  </Draggable>
                </Container>
              </template>
          </div>
          <div v-else-if="item.type == 'textarea'">
            <textarea class="form-control" id="exampleFormControlTextarea1" rows="3" v-model="formData[key]"></textarea>
          </div>

          <b-form-group v-else-if="item.type == 'time'">
            <b-form-input id="time" v-model="formData[key]" type="time"
            :disabled="formData.status && formData.status.filter(y => y.name == 'Closed')[0].value"
            :class="{ 'bg-soft-secondary': formData.status && formData.status.filter(y => y.name == 'Closed')[0].value }"
          ></b-form-input>
          </b-form-group>
          <a v-if="item.label == 'Slug'" 
            :href="`https://${currentPractice.additionalProp1.url}/${formData[key]}`" target="_blank">
            <p 
              class="ml-auto my-2 font-size-14 font-weight-medium align-self-sm-center">
              {{`https://${currentPractice.additionalProp1.url}/${formData[key]}`}}            
            </p>
          </a>
          <a v-else-if="item.label == 'Path'" 
            :href="`https://${currentPractice.additionalProp1.url}/patientnews/${formData[key]}`" target="_blank">
            <p 
              class="ml-auto my-2 font-size-14 font-weight-medium align-self-sm-center">
              {{`https://${currentPractice.additionalProp1.url}/patientnews/${formData[key]}`}}            
            </p>
          </a>
        </div>
      </div>                
    </div>

  </form>
</template>
<style lang="scss" scoped>
.ck-button__label {
  font-family: 'Montserrat';
}
input[type="date"]::-webkit-calendar-picker-indicator {
    color: rgba(0, 0, 0, 0);
    opacity: 1;
    display: block;
    background: url(../../assets/images/calendar.svg) no-repeat;
    width: 20px;
    height: 20px;
    border-width: thin;
}
.group-modal:hover {
  color: gray;
}

.media {
  display: flex;
  align-items: center;
}

.chat-list {
  li {
    .draggable-item-trigger-container {
      height: 40px;
      width: 60px;
      display: flex;
      justify-content: center;
      align-items: center;
      cursor: move;
      
      .draggable-item-trigger {
        width: 20px;
        height: 8px;
        border-top: 2px solid #333;
        border-bottom: 2px solid #333;
        margin-right: 16px;
      }
    }

    &:hover,
    &.active {
      .draggable-item-trigger {
        border-top-color: #fff;
        border-bottom-color: #fff;
      }
    }
  }
}
</style>